import Behav from './behav.js';
import Presenter from './presenter.js';

global.BEHAV = new Behav();

// load
BEHAV.add(autoAssignFormLabel)
BEHAV.add(initAdt)
BEHAV.add(initIvFields)
BEHAV.add(initIcons)
BEHAV.add(initSvg)
BEHAV.add(imgToSvg)
BEHAV.add(initScrollable)
BEHAV.add(slickSliderInit)
// BEHAV.add(initMediabox)
BEHAV.add(progressWidget)
BEHAV.add(initSocialShares)
BEHAV.add(initTooltips)

// unload
BEHAV.add(saveCurrentTabs, 'unload')

    /*554
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if(typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if(typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass+' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });
    */



$(function() {
    Date.dayNames = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    Date.abbrDayNames = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
    Date.monthNames = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'ao&ucirc;t', 'septembre', 'octobre', 'novembre', 'décembre'];
    Date.abbrMonthNames = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'ao&ucirc;t', 'sept.', 'oct.', 'nov.', 'déc.'];

    // Show
    BEHAV.add(refreshIv, 'show')

    // Editors
    if (plugins[opt('editor.text')]) global.pluginEditor = new plugins[opt('editor.text')]('.txtEditor');
    if (plugins[opt('editor.code')]) global.pluginCode = new plugins[opt('editor.code')]('.codeEditor');
    if (plugins[opt('plugin.media')]) global.pluginMedia = new plugins[opt('plugin.media')]('');

    // global onload
    BEHAV.apply('html');

    // load scripts
    // if ($('#onLoadScripts')) {
    //    eval(atob($('#onLoadScripts').html()));
    //    $('#onLoadScripts').html('');
    // }

    // déchargement
    $(document).on("page:fetch", function() {ajax_before_reload_script('body');});

    $.window.prepare({
        frameClassDefault: opt('window.class'),
        dock: 'bottom',       // change the dock direction: 'left', 'right', 'top', 'bottom'
        animationSpeed: 200,  // set animation speed
        minWinLong: 180,       // set minimized window long dimension width in pixel
        iconClose: 'shape-cross',
        iconMaximise: 'windows-blank',
        iconCascade: 'windows-blank-dual',
        iconMinimize: 'arrow-down',
        iconBookmark: 'shape-star'
    });

    if ($('#show').length) {
        const presenter = new Presenter();
        presenter.init();
    }

    /*
    $(window).on('load', function() {
        behaviours.init();
    });
    */

    // TurboLink logic is handled elsewhere or via opt() exposed in configs
})